/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integration_Status_Key_InvalidInputs */

const en_ui_integration_status_key_invalid = /** @type {(inputs: Ui_Integration_Status_Key_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key invalid`)
};

const de_ui_integration_status_key_invalid = /** @type {(inputs: Ui_Integration_Status_Key_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Key ungültig`)
};

/**
* | output |
* | --- |
* | "Key invalid" |
*
* @param {Ui_Integration_Status_Key_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integration_status_key_invalid = /** @type {((inputs?: Ui_Integration_Status_Key_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integration_Status_Key_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integration_status_key_invalid(inputs)
	return de_ui_integration_status_key_invalid(inputs)
});